import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { SCButton, SCModal, SCModalBody } from 'rollup-allspark';

const InfoModal = ({
  isOpen,
  title,
  content,
  handleClose,
  closeBtnLabel = 'Close',
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (isOpen) {
      ref.current.showModal();
    } else {
      ref.current.closeModal();
    }
  }, [isOpen]);

  const body = (
    <SCModalBody>
      <div className="flex flex-col items-start gap-y-6 normal-case font-normal text-black">
        <div className="flex w-full gap-x-2">
          <div className="flex items-center justify-center p-2 rounded-full font-medium border-8 bg-opacity-25 border-primary-lighter bg-primary">
            <i className="kt-info text-primary-dark text-2xl" />
          </div>
          <div className="flex items-center text-lg font-bold">{title}</div>
        </div>
        <div className="flex flex-col gap-y-2">{content}</div>
        <div className="flex justify-end gap-x-3 w-full">
          <SCButton
            action={handleClose}
            variant="primary"
            className="capitalize w-full"
          >
            {closeBtnLabel}
          </SCButton>
        </div>
      </div>
    </SCModalBody>
  );

  return (
    <SCModal
      ref={ref}
      variant="white"
      body={body}
      size="sm"
      onModalClose={handleClose}
    />
  );
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.element,
  handleClose: PropTypes.func,
  closeBtnLabel: PropTypes.string,
};

export default InfoModal;
